import styled from 'styled-components';

import { Button } from '@xing-com/button';
import {
  scale150,
  xdlColorControlFillTertiary,
  xdlColorDisabled,
} from '@xing-com/tokens';

export const ToolBarButton = styled(Button)`
  align-items: center;
  background: none;
  border: none;
  border-radius: 50%;
  display: flex;
  height: ${scale150};
  justify-content: center;
  position: relative;
  width: ${scale150};

  &:not(:disabled):hover {
    background-color: ${xdlColorControlFillTertiary};
    cursor: pointer;
  }

  &:disabled {
    color: ${xdlColorDisabled};
  }

  &.is-active {
    background-color: ${xdlColorControlFillTertiary};
  }
`;
